import { createSelector } from "reselect";

import { getDomainConfig } from "../../app/appSelectors";

export const getAppStoreTitle = createSelector(
    getDomainConfig, domainConfig => domainConfig?.appTitle || ''
);

export const getAppStoreLinkApple = createSelector(
    getDomainConfig, domainConfig => domainConfig?.appStoreLinkApple
);

export const getAppStoreLinkGoogle = createSelector(
    getDomainConfig, domainConfig => domainConfig?.appStoreLinkGoogle
);
